<template>
  <div class="error-page">
    <div class="container">
      <img src="@/assets/images/logo-heppi.png" srcset="@/assets/images/logo-heppi@2x.png 2x">
      <h1>
        <small>Fatura Heppi</small>
        {{ celebration }}
      </h1>
      <h2 class="text-secondary">Fatura não encontrada</h2>
      <p>A fatura que você procura não está disponível ou o link está errado. Por favor, verifique novamente o link.</p>
      <p>Caso continue sem acessar, entre em contato com o nosso suporte:</p>
      <div class="text-center">
        <template v-for="(contact, index) in contacts">
          <a class="button button-secondary ma-1" :key="index" :href="contactLink(contact.type, contact.contact)" target="_blank" rel="nofollow">
            <img v-if="contact.type === 'Whatsapp'" :key="index" src="@/assets/images/whatsapp_negative.png" srcset="@/assets/images/whatsapp_negative@2x.png 2x" />
            <img v-else-if="contact.type === 'Telefone'" :key="index" src="@/assets/images/phone_negative.png" srcset="@/assets/images/phone_negative@2x.png 2x" />
            <img v-else-if="contact.type === 'E-mail'" :key="index" src="@/assets/images/email_negative.png" srcset="@/assets/images/email_negative@2x.png 2x" />
            {{ contactLinkContent(contact.type) }}
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: '404',
  data () {
    return {
      contacts: [
        {
          type: 'Telefone',
          contact: '(81) 9 9223.1656'
        },
        {
          type: 'Whatsapp',
          contact: '(81) 9 9223.1656'
        },
        {
          type: 'E-mail',
          contact: 'fala@heppi.com.br'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['whatsappLink'])
  },
  methods: {
    numberPhone (phone) {
      return phone.replace(/[)(-. ]/g, '')
    },
    contactLink (type, title) {
      switch (type) {
        case 'E-mail':
          return 'mailto:' + title
        case 'Telefone':
          return 'tel:0' + this.numberPhone(title)
        case 'Whatsapp':
          return this.whatsappLink
      }
    },
    contactLinkContent (type) {
      switch (type) {
        case 'E-mail':
          return 'Envia um e-mail'
        case 'Telefone':
          return 'Liga'
        case 'Whatsapp':
          return 'Fala no Whatsapp'
      }
    }
  }
}
</script>
